/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { WebhookEndpointDto } from '../models/webhook-endpoint-dto';
import { webhooksEndpointsGet$Json } from '../fn/webhooks/webhooks-endpoints-get-json';
import { WebhooksEndpointsGet$Json$Params } from '../fn/webhooks/webhooks-endpoints-get-json';
import { webhooksEndpointsGet$Plain } from '../fn/webhooks/webhooks-endpoints-get-plain';
import { WebhooksEndpointsGet$Plain$Params } from '../fn/webhooks/webhooks-endpoints-get-plain';

@Injectable({ providedIn: 'root' })
export class WebhooksApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `webhooksEndpointsGet()` */
  static readonly WebhooksEndpointsGetPath = '/webhooks/endpoints';

  /**
   * List webhook endpoints.
   *
   * Lists all configured webhook endpoints for current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksEndpointsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksEndpointsGet$Plain$Response(params?: WebhooksEndpointsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEndpointDto>>> {
    const obs = webhooksEndpointsGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List webhook endpoints.
   *
   * Lists all configured webhook endpoints for current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksEndpointsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksEndpointsGet$Plain(params?: WebhooksEndpointsGet$Plain$Params, context?: HttpContext): Observable<Array<WebhookEndpointDto>> {
    const resp = this.webhooksEndpointsGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookEndpointDto>>): Array<WebhookEndpointDto> => r.body)
    );
  }

  /**
   * List webhook endpoints.
   *
   * Lists all configured webhook endpoints for current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksEndpointsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksEndpointsGet$Json$Response(params?: WebhooksEndpointsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEndpointDto>>> {
    const obs = webhooksEndpointsGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List webhook endpoints.
   *
   * Lists all configured webhook endpoints for current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksEndpointsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksEndpointsGet$Json(params?: WebhooksEndpointsGet$Json$Params, context?: HttpContext): Observable<Array<WebhookEndpointDto>> {
    const resp = this.webhooksEndpointsGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookEndpointDto>>): Array<WebhookEndpointDto> => r.body)
    );
  }

}
